{
  "countries": {
    "placeholder": "Select countries",
    "no_options": "No countries found"
  },
  "regions": {
    "placeholder": "Select regions",
    "no_options": "No regions found",
    "helper": "Leave a country's regions empty to cover the whole country."
  }
}
